export type PasswordComplexityRule = {
  id: string
  label: string
  /** Must match for this rule to pass */
  regex: RegExp
}

/** Default policy for `PasswordInput` and matching Zod `.refine` in app schemas */
export const defaultPasswordComplexityRules: PasswordComplexityRule[] = [
  { id: "length", label: "At least 8 characters", regex: /.{8,}/ },
  { id: "upper", label: "One uppercase letter", regex: /[A-Z]/ },
  { id: "lower", label: "One lowercase letter", regex: /[a-z]/ },
  { id: "number", label: "One number", regex: /[0-9]/ },
  {
    id: "special",
    label: "One special character",
    regex: /[^A-Za-z0-9]/,
  },
]

export function passwordMeetsComplexityRules(
  password: string,
  rules: PasswordComplexityRule[] = defaultPasswordComplexityRules,
): boolean {
  return rules.every((r) => r.regex.test(password))
}

/** @deprecated Use `defaultPasswordComplexityRules` — same array instance. */
export const DEFAULT_PASSWORD_COMPLEXITY_RULES = defaultPasswordComplexityRules
